import React from 'react'
import List from '../../components/List'
import { stringCompare } from '../../utils/sorters'
import Button from '../../components/UI/Button'
import {
  EditOutlined,
} from '@ant-design/icons'
import { useAuth } from '../../context/AuthProvider/useAuth'
import { useNavigate } from 'react-router-dom'

export interface IPastPayments {
  bingo_jackpot_payroll_id: string
  id:{
     round:string,
     card:string,
     jackpot:string
  },
  winner:{
     name:string,
     address:string,
     address2:string,
     addr_zipcode:string,
     addr_city:string,
     addr_state:string,
     addr_country:string,
     identification:string,
     phone_number:string,
     email:string,
     ssn:string
  },
  jackpot_information:{
     prize:string,
     prize_time:string,
     paid_time:string,
     name:string,
     location:string
  }
}

function JackpotPaymentList(props: {payments: IPastPayments[]}) {
  const history = useNavigate()
  const {canEdit} = useAuth()

  return (
    <>
      <List
        columns={[
          {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: (value: IPastPayments['id']) => <IdField {...value}/>,
            sorter: (a: IPastPayments, b: IPastPayments) => stringCompare(a.id.round, b.id.round),
            width: 110
          },
          {
            title: 'Winner',
            dataIndex: 'winner',
            key: 'winner',
            render: (value: IPastPayments['winner']) => <WinnerField {...value}/>,
            sorter: (a: IPastPayments, b: IPastPayments) => stringCompare(a.winner.name, b.winner.name),
            width: 110
          },
          {
            title: 'Jackpot information',
            dataIndex: 'jackpot_information',
            key: 'jackpot_information',
            render: (value: IPastPayments['jackpot_information']) => <JackpotInfoField {...value}/>,
            sorter: (a: IPastPayments, b: IPastPayments) => stringCompare(a.jackpot_information.name, b.jackpot_information.name),
            width: 110
          },
          {
            title: 'Edit',
            dataIndex: 'bingo_jackpot_payroll_id',
            key: 'bingo_jackpot_payroll_id',
            render: (value: IPastPayments['bingo_jackpot_payroll_id'], record: IPastPayments, index: number) => (
              <Button 
                disabled={!canEdit}
                onClick={() => history(`/jackpotspayrolls/edit/past/${value}`)}
                type='primary'
                style={{backgroundColor: '#2fa4e7'}}
              >
                <EditOutlined id={'edit-page-' + index} style={{ fontSize: '16px', color: '#FFF' }} />
              </Button>
            ),
            width: 50
          },
        ]} 
        rows={props.payments || []}
      />
    </>
  )
}

const IdField = (props: IPastPayments['id']) => {
  return (
    <>
      <div>ROUND: {props.round}</div>
      <div>CARD: {props.card}</div>
      <div>JACKPOT: {props.jackpot}</div>
    </>
  )
}

const WinnerField = (props: IPastPayments['winner']) => {
  return (
    <>
      <div>{props.name}</div>
      <div>{props.address} {props.address2 && <span>, {props.address2}</span>} {props.addr_city && <span>, {props.addr_city}</span>} {props.addr_state && <span>, {props.addr_state}</span>} {props.addr_country && <span>, {props.addr_country}</span>} {props.addr_zipcode && <span>, {props.addr_zipcode}</span>}</div>
      <div>{props.identification}</div>
      <div>{props.phone_number}</div>
      <div>{props.email}</div>
      <div>{props.ssn}</div>
    </>
  )
}

const JackpotInfoField = (props: IPastPayments['jackpot_information']) => {
  return (
    <>
      <div>NAME: {props.name}</div>
      <div>PRIZE: {props.prize}</div>
      <div>PRIZE TIME: {props.prize_time || '--'}</div>
      <div>PAID TIME: {props.paid_time || '--'}</div>
      <div>LOCATION: {props.location}</div>
    </>
  )
}
export default JackpotPaymentList